import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModelStatus } from '../../../../shared/dtos/model-status';
import { ProgressData } from '../../../../shared/dtos/progress-data';
import { ResponseDto } from '../../../../shared/dtos/response.dto';
import { SelectionItem } from '../../../../shared/dtos/selection-item';
import { ResponseModel } from '../../../../shared/models/reponse.model';
import { ProgressIndicatingService } from '../../../../shared/services/progress-indicating.service';
import { TestActivationConfig } from '../../dtos/test-activation-config.dto';
import { TopconConfigurationService } from '../../services/topcon-configuration.service';

@Component({
    selector: 'app-test-activation-config-dialog',
    templateUrl: './test-activation-config-dialog.component.html',
    styleUrls: ['./test-activation-config-dialog.component.scss']
})
export class TestActivationConfigDialogComponent {
    private progress$ = new Subject<ProgressData>();
    private unsubscribe$ = new Subject<void>();
    public config: TestActivationConfig;
    public accessCodes: SelectionItem[];
    public selectedAccessCode: SelectionItem;
    public completedProductCode: boolean = false;

    public constructor(
        public ref: DynamicDialogRef,
        config: DynamicDialogConfig,
        private topconService: TopconConfigurationService,
        private progressService: ProgressIndicatingService,
        private messageService: MessageService) {
        this.config = {
            accessCodeId: 0,
            accessCodeName: '',
            productCode: '',
            productId: 0,
            testActivationConfigId: 0,
            organizationId: config.data.organizationId,
            modelStatus: ModelStatus.NEW
        };
        this.accessCodes = config.data.accessCodes;
    }

    public onProductCodeCompleted(): void {
        this.completedProductCode = true;
    }

    public onProductCodeInputed(): void {
        this.completedProductCode = false;
    }

    public onCancelClicked(): void {
        this.ref.close(false);
    }

    public onSaveClicked(): void {
        this.progressService.show({
            progress$: this.progress$,
            initial: {
                done: false,
                header: 'Saving test activation mapping',
                details: 'Please wait...'
            }
        });

        this.topconService.addTestActivationConfig(this.config)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (): void => {
                    this.sendProgressDoneSignal();
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'All configurations saved successfully.' });
                    this.ref.close(true);
                },
                (response: unknown): void => {
                    this.sendProgressDoneSignal();
                    const res = response as { error: ResponseDto };
                    this.messageService.add({ severity: 'error', summary: 'Fail', detail: new ResponseModel(res.error).message });
                    this.config.accessCodeId = 0;
                    this.config.productCode = '';
                });
    }

    private sendProgressDoneSignal(): void {
        this.progress$.next({
            header: '',
            done: true
        });
    }
}
